import { render } from "./RecoverPassword.vue?vue&type=template&id=37606b0e&scoped=true"
import script from "./RecoverPassword.vue?vue&type=script&lang=js"
export * from "./RecoverPassword.vue?vue&type=script&lang=js"

import "@/assets/styles/auth.css?vue&type=style&index=0&id=37606b0e&scoped=true&lang=css&external"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-37606b0e"]])

export default __exports__